export const DOC_DELETE_POST = "DOC_DELETE_POST"
export const DOC_DELETE_POST_SUCCESS = "DOC_DELETE_POST_SUCCESS"
export const API_ERROR_DOC_DELETE = "API_ERROR_DOC_DELETE"

export const DOC_DOWNLOAD_POST = "DOC_DOWNLOAD_POST"
export const DOC_DOWNLOAD_POST_SUCCESS = "DOC_DOWNLOAD_POST_SUCCESS"
export const API_ERROR_DOC_DOWNLOAD = "API_ERROR_DOC_DOWNLOAD"